module.exports = __webpack_public_path__ + "files/d123e64c54922314daababbcd03fd8a1.png";